import { useState } from 'react';
import './ConfirmModal.css'; 
import { AlertTriangle } from 'lucide-react'; 

function ConfirmModal({ title, message, onConfirm, onCancel, confirmText = 'Confirmar', cancelText = 'Cancelar' }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm(); 
    setLoading(false); 
  };

  return (
    <div className="modal-backdrop">
      <div className="confirm-modal-content">
        <div className="confirm-header">
          <AlertTriangle size={48} className="confirm-icon" />
          <h2 className="confirm-title">{title || 'Confirmar Ação'}</h2>
        </div>
        <p className="confirm-message">{message}</p>
        <div className="confirm-actions">
          <button onClick={onCancel} className="button-cancel" disabled={loading}>
            {cancelText}
          </button>
          <button onClick={handleConfirm} className="button-confirm-delete" disabled={loading}>
            {loading ? 'Excluindo...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;